"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeRequestQuery = exports.UpdateChangeRequest = exports.RequestChanges = exports.ChangeRequestTransport = exports.ChangeTransport = exports.ChangeStatus = void 0;
const typebox_1 = require("@sinclair/typebox");
const alliance_order_transport_1 = require("./alliance-order-transport");
exports.ChangeStatus = typebox_1.Type.Union([
    typebox_1.Type.Literal('PENDING'),
    typebox_1.Type.Literal('APPROVED'),
    typebox_1.Type.Literal('REJECTED'),
    typebox_1.Type.Literal('CANCELLED'),
    typebox_1.Type.Literal('APPROVED_WITH_CHANGES'),
]);
exports.ChangeTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    status: exports.ChangeStatus,
    field: typebox_1.Type.KeyOf(typebox_1.Type.Pick(alliance_order_transport_1.AllianceOrderTransport, [
        'expectedDeliveryDate',
        'expectedPickupDate',
        'sharedDeliveryNotes',
        'sharedPickupNotes',
        'material',
        'expectedSize',
        'status',
    ])),
    oldValue: typebox_1.Type.Optional(typebox_1.Type.String()),
    newValue: typebox_1.Type.String(),
    notes: typebox_1.Type.Optional(typebox_1.Type.String()),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.ChangeRequestTransport = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    orderID: typebox_1.Type.String(),
    allianceOrder: typebox_1.Type.Optional(alliance_order_transport_1.AllianceOrderTransport),
    changes: typebox_1.Type.Array(exports.ChangeTransport),
    metadata: typebox_1.Type.Object({
        createdAt: typebox_1.Type.String(),
        createdByUserID: typebox_1.Type.String(),
        lastUpdatedAt: typebox_1.Type.String(),
        lastUpdatedByUserID: typebox_1.Type.String(),
    }),
});
exports.RequestChanges = typebox_1.Type.Object({
    orderID: typebox_1.Type.String(),
    changes: typebox_1.Type.Array(typebox_1.Type.Pick(exports.ChangeTransport, ['field', 'oldValue', 'newValue'])),
});
exports.UpdateChangeRequest = typebox_1.Type.Object({
    id: typebox_1.Type.String(),
    changes: typebox_1.Type.Array(typebox_1.Type.Intersect([
        typebox_1.Type.Pick(exports.ChangeTransport, ['id', 'status', 'notes']),
        typebox_1.Type.Object({ amendment: typebox_1.Type.Optional(typebox_1.Type.String()) }),
    ])),
});
exports.ChangeRequestQuery = typebox_1.Type.Partial(typebox_1.Type.Object({
    orderID: typebox_1.Type.String(),
    status: typebox_1.Type.Array(exports.ChangeStatus),
    limit: typebox_1.Type.Number(),
    offset: typebox_1.Type.Number(),
    sortBy: typebox_1.Type.String(),
    sortDescending: typebox_1.Type.Boolean(),
}));
//# sourceMappingURL=sg-changeRequest.js.map